var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoBanderaAzul(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.5 27",
    style: {
      enableBackground: "new 0 0 22.5 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#342AA0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-flag",
    className: "st0",
    d: "M21.85,1.18c-0.22,0.03-0.45,0.07-0.7,0.1c-1.41,0.2-2.84,0.32-4.26,0.37 c-1.86-0.09-3.7-0.38-5.5-0.86C9.53,0.33,7.63,0.06,5.72,0c-3.95,0-5.3,0.85-5.43,0.94L0,1.14v24.84c-0.01,0.51,0.36,0.94,0.87,1 c0.54,0.06,1.03-0.32,1.09-0.86c0-0.04,0.01-0.08,0.01-0.12V15.16c0-0.27,0.19-0.5,0.45-0.56c1.09-0.2,2.19-0.29,3.3-0.27 c1.84,0,3.57,0.7,5.39,1.09c1.92,0.5,3.88,0.77,5.86,0.81c1.69-0.03,3.38-0.18,5.05-0.46c0.28-0.04,0.48-0.28,0.49-0.56V1.74 c-0.01-0.32-0.27-0.57-0.58-0.56C21.89,1.18,21.87,1.18,21.85,1.18z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoBanderaAzul);
export default __webpack_public_path__ + "static/media/icono-bandera-azul.4cae9aabfaa135bffe675275c3bdb07a.svg";
export { ForwardRef as ReactComponent };